module.exports = __webpack_public_path__ + "static/media/hanover-big.5eadd11e.svg";